import classNames from 'classnames';
import stylesPulsantiera from 'components/scommesseFiltersList/ScommesseFiltersList.module.scss';
import { lengthIsTwo } from 'features/ippica/functions';
import { IppicaScommesseType } from 'features/ippica/types';
import { Dispatch, SetStateAction } from 'react';
import styles from './IppicaScommesseFilterList.module.scss';

export type IppicaScommesseFilterListProps = {
  gruppoList: GruppoScommessaList;
  className?: string;
  selectIndexItem?: { row: number; column: number };
  onSelectedFilter?: Dispatch<SetStateAction<{ row: number; column: number }>>;
};

export type GruppoScommessaList = Array<{ title: string; items: Array<ItemIppicaFilter> }>;

export type ItemIppicaFilter = {
  descrizione: string;
  title?: string;
  block: string;
  type: IppicaScommesseType;
  codTipoScommessa?: number;
};
export type GruppoScommessa = {
  title: string;
  items: Array<ItemIppicaFilter>;
};

export const IppicaScommesseFilterList = ({
  gruppoList,
  className,
  selectIndexItem,
  onSelectedFilter,
}: IppicaScommesseFilterListProps) => {
  const handleToggle = ({ row, column }: { row: number; column: number }) => {
    onSelectedFilter!({ row, column });
  };

  return (
    <>
      {!!gruppoList.length &&
        gruppoList.map((gruppo, index, self) => {
          // Applica la classe solo al secondo elemento e ha due elementi
          const marginTopClass = index === 1 && lengthIsTwo(self.length) ? styles.marginTopOnSecondElement : '';
          return (
            <div
              className={classNames(stylesPulsantiera.buttonWrapper, marginTopClass, className)}
              key={gruppo.title + '_' + index}
            >
              <p className={stylesPulsantiera.title}>{gruppo.title}</p>
              <div className={styles.wrapperButton}>
                <IppicaScommesseFilterListButton
                  items={gruppo.items}
                  selectIndexItem={selectIndexItem}
                  index={index}
                  handleToggle={handleToggle}
                />
              </div>
            </div>
          );
        })}
    </>
  );
};

export const IppicaScommesseFilterListButton = ({
  items,
  selectIndexItem,
  index,
  isDisable,
  handleToggle,
}: {
  items: Array<ItemIppicaFilter>;
  selectIndexItem?: { row: number; column: number };
  index: number;
  handleToggle: ({ row, column, type }: { row: number; column: number; type: IppicaScommesseType }) => void;
  isDisable?: boolean;
}) => {
  return (
    <>
      {items.map((item, indexButton) => {
        return (
          <button
            type="button"
            key={item.descrizione + '_' + index}
            className={`${stylesPulsantiera.button} ${isDisable ? styles.isDisabled : ''} ${
              selectIndexItem?.row === index && selectIndexItem?.column === indexButton ? stylesPulsantiera.active : ''
            }`}
            onClick={() => {
              handleToggle({ row: index, column: indexButton, type: item.type });
            }}
          >
            {item.descrizione}
          </button>
        );
      })}
    </>
  );
};
